'use strict';

import SlideCrousel from "./SlideCrousel";
import TabContents from "./TabContents";


let sliders = [];
sliders.push(new SlideCrousel(document.getElementsByClassName("Slider")[0], {list:"Slider__img", wrapper:"", buttons:"Slider__arrow", nav:"Slider__nav", slideUnit:"%", slideDistance:100, element:1, slideInterval:6000}));
sliders.push(new SlideCrousel(document.getElementsByClassName("ProductCarousel")[0], {list:"ProductCarousel__list", wrapper:"ProductCarousel__wrap", buttons:"ProductCarousel__arrow", nav:"", slideUnit:"px", slideDistance:190, element:5, slideInterval:4000}));

let videoTabContents = new TabContents("PenaltyVideo",false);


// WEBPACK FOOTER //
// ./assets/js/FrontPage.js